import { render, staticRenderFns } from "./lineaspedidos.vue?vue&type=template&id=25f62a80&scoped=true"
import script from "./lineaspedidos.vue?vue&type=script&lang=js"
export * from "./lineaspedidos.vue?vue&type=script&lang=js"
import style0 from "./lineaspedidos.vue?vue&type=style&index=0&id=25f62a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f62a80",
  null
  
)

export default component.exports